import { render, staticRenderFns } from "./AccountDetailsForm.vue?vue&type=template&id=66596090&scoped=true"
import script from "./AccountDetailsForm.vue?vue&type=script&lang=js"
export * from "./AccountDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66596090",
  null
  
)

export default component.exports